import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import IncidentViewer from '../components/incident-viewer/IncidentViewer';
import { Button } from '@dnb/eufemia';
import { chevron_left as ChevronLeft } from '@dnb/eufemia/icons';
import './incidents.css';

export default function OngoingIncidentPage({ incidents = [] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine if we're on the business tab or personal tab
  const isBusiness = location.pathname.startsWith('/business');
  const homeRoute = isBusiness ? '/business' : '/';
  const archiveRoute = isBusiness ? '/business/archive' : '/archive';

  if (!incidents) {
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <p>Loading incidents...</p>
        </div>
      </main>
    );
  }

  try {
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <div className="incidents-header">
            <Button 
              className="back-button" 
              text={t('Back')} 
              variant="secondary"
              size="medium"
              icon={ChevronLeft}
              icon_position="left"
              onClick={() => navigate(homeRoute)}
            />
            
            <Button 
              className="archive-button" 
              text={t('Archive')} 
              variant="secondary"
              size="medium"
              onClick={() => navigate(archiveRoute)}
            />
          </div>
          
          <h1 className="incidents-page-title">
            {t('Ongoing incidents')}
          </h1>

          <IncidentViewer 
            incidents={incidents}
            filterType="ongoing"
          />
        </div>
      </main>
    );
  } catch (error) {
    console.error('OngoingIncidentPage render error:', error);
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <p>Error loading incidents page: {error.message}</p>
        </div>
      </main>
    );
  }
}

OngoingIncidentPage.propTypes = {
  incidents: PropTypes.array,
};
